import React, { useState } from "react";

const SendNotificationToCustomers = () => {
  const [title, setTitle] = useState("🎉 Special Offer!");
  const [body, setBody] = useState("Get ₹50 OFF on your next order!");
  const [type, setType] = useState("offer");
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const offerTemplates = [
    {
      name: "Weekend Special",
      title: "🎉 Weekend Special Offer!",
      body: "Get ₹50 OFF on all orders this weekend. Use code: WEEKEND50",
      type: "offer"
    },
    {
      name: "New Menu",
      title: "🍽️ New Menu Items Available!",
      body: "Check out our latest delicious additions to the menu!",
      type: "announcement"
    },
    {
      name: "Delivery Update",
      title: "🚚 Delivery Update",
      body: "Your order is on the way! Expected delivery in 30 minutes.",
      type: "delivery"
    },
    {
      name: "Custom",
      title: "",
      body: "",
      type: "custom"
    }
  ];

  const handleTemplateChange = (template) => {
    setTitle(template.title);
    setBody(template.body);
    setType(template.type);
  };

  const handleSend = async () => {
    if (!title.trim() || !body.trim()) {
      setStatus("❌ Please fill in both title and message.");
      return;
    }

    setLoading(true);
    setStatus("");

    try {
      const response = await fetch("https://us-central1-jr-homemade-foods.cloudfunctions.net/sendNotification", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ title: title.trim(), body: body.trim(), type }),
      });
      const result = await response.json();
      if (result.success) {
        setStatus(`✅ Notification sent successfully!`);
        setTitle("🎉 Special Offer!");
        setBody("Get ₹50 OFF on your next order!");
        setType("offer");
      } else {
        setStatus(`❌ ${result.error || result.message || 'Failed to send notification'}`);
      }
    } catch (error) {
      console.error("❌ Notification error:", error);
      setStatus(`❌ Error: ${error.message || 'Failed to send notification'}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-sm p-6 border border-green-100">
      <h2 className="text-xl font-bold text-green-700 mb-4">🔔 Send Notification to All Customers</h2>
      
      {/* Template Selection */}
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          📝 Quick Templates
        </label>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          {offerTemplates.map((template, index) => (
            <button
              key={index}
              onClick={() => handleTemplateChange(template)}
              className="p-3 text-left border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
            >
              <div className="font-medium text-gray-800">{template.name}</div>
              <div className="text-sm text-gray-600">
                {template.title || "Custom message"}
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Notification Form */}
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Notification Title *
          </label>
          <input
            type="text"
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
            placeholder="Enter notification title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            maxLength={100}
          />
          <div className="text-xs text-gray-500 mt-1">
            {title.length}/100 characters
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Message *
          </label>
          <textarea
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
            placeholder="Enter your message"
            value={body}
            onChange={(e) => setBody(e.target.value)}
            rows={4}
            maxLength={500}
          />
          <div className="text-xs text-gray-500 mt-1">
            {body.length}/500 characters
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Notification Type
          </label>
          <select
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
            value={type}
            onChange={(e) => setType(e.target.value)}
          >
            <option value="offer">🎉 Offer/Promotion</option>
            <option value="announcement">📢 Announcement</option>
            <option value="delivery">🚚 Delivery Update</option>
            <option value="reminder">⏰ Reminder</option>
            <option value="general">📱 General</option>
          </select>
        </div>

        <button
          onClick={handleSend}
          disabled={loading || !title.trim() || !body.trim()}
          className="w-full bg-green-600 text-white py-3 px-4 rounded-lg hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors duration-200 font-medium"
        >
          {loading ? (
            <span className="flex items-center justify-center">
              <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Sending Notification...
            </span>
          ) : (
            "📤 Send to All Customers"
          )}
        </button>

        {status && (
          <div className={`mt-4 p-3 rounded-lg text-sm ${
            status.includes("✅") 
              ? "bg-green-50 text-green-700 border border-green-200" 
              : "bg-red-50 text-red-700 border border-red-200"
          }`}>
            {status}
          </div>
        )}
      </div>

      {/* Info Section */}
      <div className="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
        <h3 className="font-medium text-blue-800 mb-2">ℹ️ How it works:</h3>
        <ul className="text-sm text-blue-700 space-y-1">
          <li>• Notification will be sent to all customers with FCM tokens</li>
          <li>• Customers will receive push notification on their devices</li>
          <li>• Notification history is logged for analytics</li>
          <li>• Only admins can send notifications</li>
        </ul>
      </div>
    </div>
  );
};

export default SendNotificationToCustomers; 